import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import FileManagement from "../file_management/file_management";

export const ImageExtensions = ["jpeg", "png", "jpg", "gif", "webp"];
export const DocumentExtensions = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "zip",
  "rar",
  "dwg",
  "jpeg",
  "png",
  "jpg",
];

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

/**
 * Dialog chọn file từ Quản lý tài liệu.
 * FileManagement ghi đè danh sách đang chọn mỗi lần đổi lựa chọn (và có thể set null),
 * nên dialog giữ state riêng và chỉ trả kết quả khi bấm "Chọn".
 * onConfirm nhận mảng [{ fileId, fileName, filePreview }]
 */
const FilePickerDialog = ({
  isOpen,
  onClose,
  onConfirm,
  multiple = false,
  acceptedFiles = ImageExtensions,
  title = "Quản lý file",
}) => {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const selectedFiles = files || [];

  const handleConfirm = () => {
    onConfirm(selectedFiles);
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      fullWidth={true}
      maxWidth="md"
      className="dialog-preview-form"
    >
      <DialogTitle disableTypography>
        <Typography variant="h6">{title}</Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <FileManagement
          files={selectedFiles}
          setFiles={setFiles}
          multiple={multiple}
          acceptedFiles={acceptedFiles}
        />
      </DialogContent>
      <DialogActions>
        <Typography variant="body2" className="mr-auto ml-2 text-muted">
          Đã chọn {selectedFiles.length} file
        </Typography>
        <Button
          type="button"
          onClick={onClose}
          variant="contained"
          startIcon={<CloseIcon />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          startIcon={<SaveIcon />}
          disabled={selectedFiles.length === 0}
          onClick={handleConfirm}
        >
          Chọn
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilePickerDialog;
